import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: undefined,
  isLoadingUser: false,
};

const passwordlessOidcSlice = createSlice({
  name: 'passwordlessOidc',
  initialState,
  reducers: {
    userPasswordlessExpired(state) {
      return initialState;
    },
    silentPasswordlessRenewError(state) {
      return initialState;
    },
    sessionPasswordlessTerminated(state) {
      return initialState;
    },
    userPasswordlessSignedOut(state) {
      return initialState;
    },
    userPasswordlessFound(state, action) {
      state.user = action.payload;
      state.isLoadingUser = false;
    },
    loadingPasswordlessUser(state) {
      state.isLoadingUser = true;
    },
    clearPasswordlessTokens() {
      return initialState;
    },
  },
});

export const loadPasswordlessUser = (store, userManager) => {
  store.dispatch(loadingPasswordlessUser());

  return userManager
    .getUser()
    .then((user) => {
      if (user && !user.expired) {
        store.dispatch(userPasswordlessFound(user));
      } else if (!user || (user && user.expired)) {
        store.dispatch(userPasswordlessExpired());
      }
      return user;
    })
    .catch();
};

export const {
  userPasswordlessExpired,
  silentPasswordlessRenewError,
  sessionPasswordlessTerminated,
  userPasswordlessSignedOut,
  userPasswordlessFound,
  loadingPasswordlessUser,
  clearPasswordlessTokens,
} = passwordlessOidcSlice.actions;
export const passwordLessOidcReducer = passwordlessOidcSlice.reducer;
